import { render, staticRenderFns } from "./InventoryForm.vue?vue&type=template&id=58489b81"
import script from "./InventoryForm.vue?vue&type=script&lang=js"
export * from "./InventoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports